// #78 SuggField: the pinned field of DC-33. An empty, editable TextArea labelled with his feature name (*Interview
// recommendations*, *Debrief preparation*) and the hint "Human decision remains." Nothing generates its text and no
// model or vendor is named: what is in it, a person wrote. Error: the field standard; blocked: read-only with the
// inline reason; mode="view": the text alone.

import type { ReactNode } from "react";
import { type ControlProps } from "../core/Button";
import { Field, TextArea } from "../core/Field";
import { cx } from "../lib/cx";
import { G1_LABELS } from "./labels";

export interface SuggFieldProps extends ControlProps {
  /** Which of his features the field stands for. */
  feature: "interviewRecommendations" | "debriefPreparation";
  value?: string | undefined;
  onChange?: ((value: string) => void) | undefined;
  /** A validation error sentence. */
  error?: ReactNode | undefined;
  /** After the label (a FieldState once the text was edited). */
  labelSlot?: ReactNode | undefined;
  rows?: number | undefined;
  id?: string | undefined;
  className?: string | undefined;
}

export function SuggField({ feature, value, onChange, error, labelSlot, rows = 3, id, can, blocked, mode, hs, className }: SuggFieldProps) {
  if (can === false) return null;
  return (
    <Field
      label={G1_LABELS[feature]}
      hint={G1_LABELS.humanDecision}
      error={error}
      labelSlot={labelSlot}
      blocked={blocked}
      mode={mode}
      id={id}
      className={cx("mc-sugg", className)}
    >
      <TextArea rows={rows} value={value ?? ""} onChange={(event) => onChange?.(event.target.value)} hs={hs} />
    </Field>
  );
}
